import { motion } from 'framer-motion';
import { PricingToggle } from './pricing-toggle';

export function PricingHeader() {
  return (
    <div className="text-center">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <h1 className="bg-gradient-to-r from-indigo-500 to-purple-500 bg-clip-text text-4xl font-bold text-transparent sm:text-5xl">
          Simple, Transparent Pricing
        </h1>
        <p className="mt-4 text-lg text-gray-600">
          Start free, upgrade when you need more
        </p>
      </motion.div>
      <div className="mt-8">
        <PricingToggle />
      </div>
    </div>
  );
}